export function mergeIntegration(current, updated) {
    return current.filter((i)=>i.source !== updated.source).concat([
        updated
    ]);
}
